import React, { useState, useEffect } from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  TableContainer,
  Typography,
  Checkbox,
} from "@mui/material";

const PreviewTablePayment = ({ rows = [], onSelectionChange }) => {
  const [selectedRows, setSelectedRows] = useState([]);

  // Καθάρισε επιλογές όταν αλλάξουν τα δεδομένα
  // Default-select all rows that are NOT disabled whenever rows change
  useEffect(() => {
    const defaultSelected = rows
      .map((row, index) => (!row.disabled ? index : null))
      .filter((i) => i !== null);

    setSelectedRows(defaultSelected);
    if (onSelectionChange) {
      const selectedData = defaultSelected.map((i) => rows[i]);
      onSelectionChange(selectedData);
    }
  }, [rows]); // runs whenever rows change

  const handleToggle = (index) => {
    const newSelection = selectedRows.includes(index)
      ? selectedRows.filter((i) => i !== index)
      : [...selectedRows, index];

    setSelectedRows(newSelection);

    // Επιστροφή των επιλεγμένων γραμμών προς τον γονέα
    if (onSelectionChange) {
      const selectedData = newSelection.map((i) => rows[i]);
      onSelectionChange(selectedData);
    }
  };

  // Επιλογή / αποεπιλογή όλων
  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const allIndexes = rows.map((_, i) => i);
      setSelectedRows(allIndexes);
      if (onSelectionChange) onSelectionChange(rows);
    } else {
      setSelectedRows([]);
      if (onSelectionChange) onSelectionChange([]);
    }
  };

  if (!rows.length) return null;

  return (
    <TableContainer component={Paper} sx={{ mt: 2, overflowX: "auto" }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell align="center" sx={{ width: 60 }}>

            </TableCell>
            <TableCell>
              <Typography fontWeight={600}>Τύπος Αίτησης</Typography>
            </TableCell>
            <TableCell align="center">
              <Typography fontWeight={600}>Πλήθος</Typography>
            </TableCell>
            <TableCell align="center">
              <Typography fontWeight={600}>Τρέχουσα Κατάσταση</Typography>
            </TableCell>
            <TableCell align="center">
              <Typography fontWeight={600}>Επόμενη Κατάσταση</Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <TableRow
              key={index}
              sx={{
                backgroundColor:
                  index % 2 === 0 ? "rgba(0,0,0,0.02)" : "transparent",
              }}
            >
              <TableCell align="center">
                <Checkbox
                  disabled={row.disabled}
                  color="primary"
                  checked={selectedRows.includes(index)}
                  onChange={() => handleToggle(index)}
                />
              </TableCell>
              <TableCell>{row.type}</TableCell>
              <TableCell align="center">{row.count}</TableCell>
              <TableCell align="center">{row.currentStatus}</TableCell>
              <TableCell align="center">{row.newStatus}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PreviewTablePayment;
